import * as React from "react";
import { forwardRef } from "react";
const SvgBckgBrandedTop = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 360, height: 50, viewBox: "0 0 360 50", fill: "none", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M118.625 0C135.194 8.86307 159.763 16.2927 197 20C248.171 25.0946 285.876 19.8072 317.465 15.3774C332.805 13.2263 346.702 11.2774 360 10.8177V0H118.625Z", fill: "#C5E8EA" }));
const ForwardRef = forwardRef(SvgBckgBrandedTop);
export default ForwardRef;
